    <p-columnFilter [field]=field display="menu" #filterId [showAddButton]="false" [showMatchModes]="false"
        [showOperator]="false" [showClearButton]="false" [showApplyButton]="false"
        (click)="filterOpen(filterFormGroup, field, 'matchModeControl', 'valueControl');">
        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <form [formGroup]="filterFormGroup"
                (keydown.enter)="apply(filterFormGroup, field);filterId.hide()">
                <p-dropdown [options]="matchModeOptions" formControlName="matchModeControl" optionLabel="label"
                    optionValue="value"></p-dropdown>
                <input type="text" formControlName="valueControl" pInputText class="mt-1" >
                <div class="d-flex justify-content-around mt-3">
                    <button type="button" class="btn btn-danger btn-sm column-filter-btn" pRipple
                        (click)="clear(field);filterId.hide();initialSetup()">Clear</button>
                    <button type="button" class="btn btn-success btn-sm column-filter-btn" pRipple
                        (click)="apply(filterFormGroup, field);filterId.hide()" [disabled]="!filterFormGroup.valid">Apply</button>
                </div>
            </form>
        </ng-template>
    </p-columnFilter>
